import { render, staticRenderFns } from "./addData_3.vue?vue&type=template&id=1824d7f8&scoped=true"
import script from "./addData_3.vue?vue&type=script&lang=js"
export * from "./addData_3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1824d7f8",
  null
  
)

export default component.exports